import { defineStore } from 'pinia'

export const useLayoutStore = defineStore('layout', () => {
  const [isNavbarOpen, toggleNavbar] = useToggle(false)
  return { isNavbarOpen, toggleNavbar }
})
